<template>
	<div>
		<the-import />
		<the-export />
	</div>
</template>

<script>
import TheImport from './the-import';
import TheExport from './the-export';

export default {
	components: { TheImport, TheExport },
};
</script>

